// Dependencies
import Slider from 'modules/slider';


class CasesSlider extends Slider {
  /**
   * Constructor: Cases Slider Constructor.
   */
  constructor(options = {}) {
    // Inherit constructor.
    super(options);
    
    // Elements
    this._grid = options.grid;
    this._nav  = options.nav;

    // Attributes
    this._loop = false;

    // Visible Nodes
    this.visible();

    // Init
    this.change(this._index, false);
  }


  /**
   * Change: Deactivate current node and activate selected one.
   *
   * @param {Int} index - Selected index.
   */
  change(index, running = true) {
    // Inherit `change` method.
    super.change(index, running);

    // Translation
    this.translate();
  }


  /**
   * Visible: Define how many nodes are visible.
   */
  visible() {
    // Nav
    this._nav.style.display = 'none';

    // Prevent
    if (this._nodes.length === 0) {
      return;
    }

    // Default
    let rows = 2;
    let cols = 4;

    // Large
    if (window.innerWidth <= 1030) {
      rows = 2;
      cols = 3;
    }

    // Medium
    if (window.innerWidth <= 780) {
      rows = 1;
      cols = 2;
    }

    // Small
    if (window.innerWidth <= 560) {
      rows = 1;
      cols = 1;
    }

    // Update Attributes
    this._box    = this._nodes[0].getBoundingClientRect();
    this._width  = this._box.width;
    this._height = this._box.height;

    let show = rows * cols;
    let left = this._nodes.length - show;

    this._length = Math.ceil(left / rows);

    this._min = 0;
    this._max = this._length;

    // Nav
    if (this._nodes.length > show) {
      this._nav.style.display = 'flex';
    }
  }


  /**
   * Translate: Translate grid horizontally.
   */
  translate() {
    if (!this._grid) {
      return;
    }

    // Complete Method
    const complete = () => {
      // Update attributes
      this._running = false;
    };

    // Translation
    let x  = this._width;
        x *= this._index * -1;

    TweenMax.to(this._grid, 0.6, {
      x: x,
      ease: Quart.easeOut,
      onComplete: complete,
    });
  }


  /**
   * Reset: Reset Cases.
   */
  reset() {
    // Reset Attributes
    this._index   = 0;
    this._running = false;

    // Reset grid
    if (this._grid) {
      TweenMax.killTweensOf(this._grid);
      TweenMax.set(this._grid, {
        clearProps: 'all'
      });
    }
  }


  /**
   * Resize: Resize Cases.
   */
  resize() {
    // Reset Cases
    this.reset();

    // Visible Nodes
    this.visible();
  }


  /**
   * Update: Update Cases.
   */
  update() {
    // Update Nodes
    this._grid  = this._root.querySelector('.cases__grid');
    this._nodes = [...this._root.querySelectorAll('.case-card')];

    // Update Attributes
    this._length = this._nodes.length;

    this._min = 0;
    this._max = this._length - 1;

    // Reset Cases
    this.reset();

    // Visible Nodes
    this.visible();
  }
}

export default CasesSlider;


// WEBPACK FOOTER //
// ./src/js/layouts/cases/slider.js